import React from "react";

interface Props {
    filters: { isEligible1099?: boolean };
}

export const Eligible1099FilterLabel: React.FC<Props> = ({
    filters: { isEligible1099 },
}) => {
    if (isEligible1099 === true) {
        return <>Eligible</>;
    }
    if (isEligible1099 === false) {
        return <>Not eligible</>;
    }
    return null;
};
